import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "src/app/ui-components/buttons/button.module";
import { CardSwitchComponent } from "./card-switch.component";

@NgModule({
    declarations:[CardSwitchComponent],
    imports:[ButtonModule,CommonModule],
    exports:[CardSwitchComponent]
})
export class CardSwitchModule{
    constructor(){

    }
}